import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormCapsule: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="form-capsule, button"><path d="M14.5 4.75H9.5C5.49594 4.75 2.25 7.99594 2.25 12C2.25 16.0041 5.49594 19.25 9.5 19.25H14.5C18.5041 19.25 21.75 16.0041 21.75 12C21.75 7.99594 18.5041 4.75 14.5 4.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFormCapsule;
